import { render } from "./boost-filter.vue?vue&type=template&id=40c9d580"
import script from "./boost-filter.vue?vue&type=script&lang=js"
export * from "./boost-filter.vue?vue&type=script&lang=js"

import "./boost-filter.vue?vue&type=style&index=0&id=40c9d580&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__